import Component from '@glimmer/component';
import { get } from '@ember/object';
import { setComponentTemplate } from '@ember/component';

// Fixed setComponentTemplate that should already be exposed in TypeScript

// FIXME: Surely `Record<any, any>` cannot be right.
/* eslint-disable @typescript-eslint/ban-types */

/* eslint-enable @typescript-eslint/ban-types */

// stateful properties

const defineMappedStateToProps = (target, stateObjectKeyPath, mapStateToProps) => {
  Object.defineProperty(target, '_stateToProps', {
    get() {
      // FIXME(steckel): Remove any and utilize State generic.
      const state = get(this, stateObjectKeyPath);
      return mapStateToProps(state, this.args);
    }
  });
};

// FIXME(steckel): Make type-safe.
// I'm not entirely sure how we'd go about making propertyDescriptors typesafe.
const statefulPropertyDescriptor = (mappedStatePath, propertyKey) => ({
  get() {
    return this[mappedStatePath][propertyKey];
  }
});
const defineStatefulProperty = target => propertyName => Object.defineProperty(target, propertyName, statefulPropertyDescriptor('_stateToProps', propertyName));

// actions

const wrapActionCreator = (emit, fn) => (...args) => {
  const val = fn(...args);
  if (val == null) {
    return;
  }
  emit(val);
};
const defineActionCreatorHandler = (target, emit) => ([propertyName, actionCreator]) => Object.defineProperty(target, propertyName, {
  value: wrapActionCreator(emit, actionCreator)
});

/**
 * TODO(steckel): Remove initialState argument and refactor Component
 * construction accordingly. This will be unlocked when Workflow internals are
 * re-implemented with a BehaviorSubject allowing for synchronous state
 * fetching in the constructor.
 */
const connect = serviceRegistrationKey => (mapStateToProps, mapActionsToProps) => template => {
  class StatefulComponent extends Component {
    constructor(owner, args) {
      super(owner, args);
      // FIXME(steckel): make registry access type-safe
      const workflowService = owner.lookup(`service:${serviceRegistrationKey}`);
      Object.defineProperty(this, 'workflowService', {
        value: workflowService
      });
      if (mapStateToProps != null) {
        defineMappedStateToProps(this, 'workflowService.state', mapStateToProps);

        // define each stateful property
        Object.keys(mapStateToProps(workflowService.state, args)).forEach(defineStatefulProperty(this));
      }
      if (mapActionsToProps != null) {
        const emit = action => workflowService.emit(action);
        // FIXME(steckel): Not sure if we can keep each handler's parameter
        // types at this level.
        const entries = Object.entries(mapActionsToProps(args));
        entries.forEach(defineActionCreatorHandler(this, emit));
      }
    }
  }
  setComponentTemplate(template, StatefulComponent);
  return StatefulComponent;
};
export default connect;